<div id="contacts" class="page-layout simple left-sidebar inner-sidebar inner-scroll">
  <!-- HEADER -->
  <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="start"
       fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

          <button mat-icon-button class="sidebar-toggle mr-12" fxHide.gt-sm
                  (click)="toggleSidebar('contacts-main-sidebar')">
              <mat-icon>menu</mat-icon>
          </button>

      </div>
      <!-- / APP TITLE -->

  </div>
  <!-- / HEADER -->
  <!-- CONTENT -->
  <div class="content">

      <!-- SIDEBAR -->
      <fuse-sidebar class="sidebar" name="contacts-main-sidebar" position="left" lockedOpen="gt-sm">

          <!-- SIDEBAR CONTENT -->
          <div class="content" fusePerfectScrollbar>
              <app-lista-adquiridos
                [@animate]="{value:'*'}"
                [productosFiltrados]="productosFiltrados"
                [producto]="producto"
              >
              </app-lista-adquiridos>
          </div>
          <!-- / SIDEBAR CONTENT -->

      </fuse-sidebar>
      <!-- / SIDEBAR -->

      <!-- CENTER -->
      <div class="center p-24 pb-56 pr-sm-92" fusePerfectScrollbar>

          <!-- CONTENT -->
          <div class="content">
              <app-lista-status></app-lista-status>
          </div>
          <!-- / CONTENT -->

      </div>
      <!-- / CENTER -->

  </div>
  <!-- / CONTENT-->
</div>
